import { Copy, Check, History } from 'lucide-react';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';

interface CallbackUrlInfoProps {
  callbackUrl: string;
  showCallbackLogs: boolean;
  onToggleLogs: () => void;
}

export default function CallbackUrlInfo({ callbackUrl, showCallbackLogs, onToggleLogs }: CallbackUrlInfoProps) {
  const { copied, copy } = useCopyToClipboard();

  return (
    <div className="flex items-center gap-2">
      <span className="truncate max-w-[300px]" title={callbackUrl}>
        {callbackUrl}
      </span>
      <button
        type="button"
        onClick={() => copy(callbackUrl)}
        className="flex-shrink-0 p-1 rounded hover:bg-muted transition-colors"
        aria-label={copied ? "URL copied" : "Copy URL to clipboard"}
        title={copied ? "Copied!" : "Copy URL"}
      >
        {copied ? (
          <Check className="h-3.5 w-3.5 text-green-500" />
        ) : (
          <Copy className="h-3.5 w-3.5 text-muted-foreground" />
        )}
      </button>
      <button
        type="button"
        onClick={onToggleLogs}
        className={`flex-shrink-0 p-1 rounded hover:bg-muted transition-colors ${showCallbackLogs ? 'bg-primary/20 text-primary' : ''}`}
        aria-label="View callback delivery logs"
        aria-pressed={showCallbackLogs}
        title="View delivery logs"
      >
        <History className={`h-3.5 w-3.5 ${showCallbackLogs ? 'text-primary' : 'text-muted-foreground'}`} />
      </button>
    </div>
  );
}
